import { ConfigProvider, message, theme } from "antd";
import zhCN from "antd/locale/zh_CN";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { installAuthenticatedGuideAgent } from "./integrations/guideAgent";
import { installAgentNavigation } from "./integrations/agentNavigation";
import { router } from "./router";
import "./styles/index.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root not found");

const removeAgentNavigation = installAgentNavigation({
  origin: window.location.origin,
  navigate: (href) => router.navigate({ href }),
  onError: () => {
    void message.error("页面跳转失败，请稍后重试。");
  },
});
const removeAuthenticatedGuide = installAuthenticatedGuideAgent(
  import.meta.env.VITE_GUIDE_AGENT_ORIGIN,
  import.meta.env.VITE_GUIDE_AGENT_INTEGRATION || "trust-guide",
  import.meta.env.VITE_GUIDE_AGENT_ALLOW_HTTP_LOOPBACK === "true",
);
if (import.meta.hot)
  import.meta.hot.dispose(() => {
    removeAgentNavigation();
    removeAuthenticatedGuide();
  });

createRoot(root).render(
  <StrictMode>
    <ConfigProvider
      locale={zhCN}
      theme={{
        algorithm: theme.defaultAlgorithm,
        token: {
          colorPrimary: "#42b983",
          borderRadius: 8,
          fontSize: 14,
        },
      }}
    >
      <App />
    </ConfigProvider>
  </StrictMode>,
);
